import routes from './routes'
import store from './store'

export default {
    name: 'm-deploy',
    store: store,
    routes: routes
}